import { Box, Button } from '@mui/material';
import React from 'react';
import Text from '../../../components/Text';
import { styles } from './empty.form.styles';

interface Props {
  handleEmptyFormSubmit: () => void
}
const EmptyAsyncTaskPresenter: React.FunctionComponent<Props> = ({
  handleEmptyFormSubmit,
}) => {
  const classes = styles();
  return (
    <Box className={classes.root}>
      <Box display="flex" justifyContent="flex-end">
        <Button
          className={classes.submitButton}
          onClick={handleEmptyFormSubmit}
          variant="contained"
          color="secondary"
        >
          <Text translation="common.submit" />
        </Button>
      </Box>
    </Box>
  );
};
export default EmptyAsyncTaskPresenter;
